var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.96 3.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003a4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.46,3.66h-.19c-2.39-.31-4.86-.5-7.36-.59Q6.54,2.88,1.6,3.2a1.5,1.5,0,1,1-.2-3C4.8,0,8.33-.06,12,.07c2.59.08,5.16.29,7.64.61a1.5,1.5,0,0,1-.19,3Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.4818ea6bdaa14dce4d1ece0497113409.svg";
export { ForwardRef as ReactComponent };